import { getAppFeatures } from '@utils/getAppFeatures'
import { ExternalSvg } from 'components'
import { JSX } from 'react'

export const Logo = (): JSX.Element => {
  const features = getAppFeatures()
  return <ExternalSvg url={features?.resources?.navbarLogo} />
}
